// pages/events/Events.js
import React, { useEffect, useState } from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {
  Row,
  Col,
  Button,
  Container,
  Table,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEventsAction,
  fetchSingleEventAction,
  deleteEventAction,
} from "./EventAction";
import { EventForm } from "../../components/event/EventForm";
import {
  selectEvents,
  selectSelectedEvent,
  selectIsLoading,
} from "./EventSelectors";

const Events = () => {
  const dispatch = useDispatch();

  const events = useSelector(selectEvents);
  const selectedEvent = useSelector(selectSelectedEvent);
  const isLoading = useSelector(selectIsLoading);

  const [showForm, setShowForm] = useState(false);
  const [showFinishForm, setShowFinishForm] = useState(false);
  const [editEventId, setEditEventId] = useState(null);
  const [editInitial, setEditInitial] = useState(null);

  useEffect(() => {
    dispatch(fetchEventsAction());
  }, [dispatch]);

  const handleEdit = (id) => {
    setEditEventId(id);
    const existing = Array.isArray(events)
      ? events.find((e) => e._id === id)
      : null;
    setEditInitial(existing || null);
    dispatch(fetchSingleEventAction(id)); // refresh in background
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      await dispatch(deleteEventAction(id));
      dispatch(fetchEventsAction()); // refresh list
    }
  };

  const handleAddNew = () => {
    setEditEventId(null);
    setEditInitial(null);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditEventId(null);
    setEditInitial(null);
  };

  const handleFinish = (id) => {
    setEditEventId(id);
    const existing = Array.isArray(events)
      ? events.find((e) => e._id === id)
      : null;
    setEditInitial(existing || null);
    setShowFinishForm(true);
  };

  const handleCloseFinishForm = () => {
    setShowFinishForm(false);
    setEditEventId(null);
    setEditInitial(null);
  };

  return (
    <DefaultLayout>
      <Container>
        <Row className="py-2">
          <Col>
            <h5>Events</h5>
            <div className="text-end">
              <Button variant="primary" onClick={handleAddNew}>
                Add New Event
              </Button>
            </div>
            <hr />
          </Col>
        </Row>

        {isLoading && (
          <div className="text-center py-3">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <Row>
          <Col>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Location</th>
                  <th>Created On</th> {/* ✅ new column */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(events) && events.length > 0 ? (
                  events.map((e) => (
                    <tr key={e._id}>
                      <td>{e.name}</td>
                      <td>{e.description}</td>
                      <td>
                        {e.startDate
                          ? new Date(e.startDate).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>
                        {e.endDate
                          ? new Date(e.endDate).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>{e.location ?? "N/A"}</td>
                      <td>
                        {e.createdAt
                          ? new Date(e.createdAt).toLocaleDateString()
                          : "-"}
                      </td>
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEdit(e._id)}
                        >
                          Edit
                        </Button>

                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDelete(e._id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      No events found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* Add / Edit Modal */}
        <Modal show={showForm} onHide={handleCloseForm} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {editEventId ? "Edit Event" : "Add New Event"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EventForm
              eventId={editEventId}
              initialData={editInitial}
              selectedEvent={selectedEvent}
              onClose={() => {
                handleCloseForm();
                dispatch(fetchEventsAction());
              }}
            />
          </Modal.Body>
        </Modal>
      </Container>
    </DefaultLayout>
  );
};

export default Events;
